import { Stack, Typography } from '@mui/material';
import { ROUTES } from '@/constants/path.constants';
import CustomMuiButton from '@/components/button/CustomMuiButton';
import theme from '@/app/theme';
import useCheckIsMobileSize from '@/hooks/useCheckIsMobileSize';
import { Header } from '@/shared/ui/organisms';
import gradientBackground from '@/styles/background.animation.module.css';

const CustomError = ({ errorCode = 'ERROR', message, redirectTo = ROUTES.getMainDashboard() }: { errorCode?: string; message?: string | React.ReactNode; redirectTo?: string }) => {
  const isMobile = useCheckIsMobileSize();
  const mobileGap = '40px';
  return (
    <Stack
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        paddingBottom: '10vh',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      direction={isMobile ? 'column' : 'row'}
      gap={isMobile ? mobileGap : '64px'}
      className={gradientBackground['gradient-box']}
    >
      <Header />
      <Typography variant="h1" fontWeight="light" color={theme.palette.blue[400]} fontSize={isMobile ? '48px' : '80px'}>
        {errorCode}
      </Typography>
      <Stack gap={isMobile ? mobileGap : '24px'}>
        <Typography variant={isMobile ? 'subtitle1' : 'h4'} color="textPrimary" fontWeight="normal" textAlign={isMobile ? 'center' : 'left'}>
          죄송합니다.
          <br />
          {message}
        </Typography>
        <CustomMuiButton
          type="SECONDARY"
          label="대시보드로 가기"
          sx={{
            background: 'rgba(255, 255, 255, 0.5)',
            borderColor: theme.palette.blue[400],
            color: theme.palette.blue[400],
            ':hover': {
              backgroundColor: theme.palette.blue[400],
              color: 'white'
            }
          }}
          onClick={() => window.location.replace(redirectTo)}
        />
      </Stack>
    </Stack>
  );
};

export default CustomError;
